import { render, staticRenderFns } from "./CompensatingFactorsTable.vue?vue&type=template&id=1daf5b7c&"
import script from "./CompensatingFactorsTable.vue?vue&type=script&lang=js&"
export * from "./CompensatingFactorsTable.vue?vue&type=script&lang=js&"
import style0 from "./CompensatingFactorsTable.vue?vue&type=style&index=0&id=1daf5b7c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports